<template>
    <div class="role-component ivu-card">
        <Row class="padding-10">
            <Col span="12">
            <div class="page-title">
                <title-text :inline="true" :onlyText="false">所在应用</title-text>
            </div>
            <Menu active-name="1" class="menu-group scrollbar" style="width: auto">
                <MenuItem v-for="item in obj.appList" :key="item.id" :name="item.id" @click.native="getRoleList(item.id, item.name)">
                    {{ item.name }}
                </MenuItem>
            </Menu>
            </Col>
            <Col span="12">
            <Input suffix="ios-search" class="cursor-point" v-model="searchTxt" @click.native.stop="searchRole" placeholder="请输入角色名称" clearable style="width: auto" @on-click="searchRole" @on-enter="searchRole"/>
            <CheckboxGroup v-if="rightList.length > 0" v-model="choiceData" class="padding-10 role-list scrollbar">
                <Checkbox v-for="item in rightList" :key="item.id" class="margin-tb-10" :label="item.id">{{ item.roleName }}</Checkbox>
            </CheckboxGroup>
            <div v-else class="text-center no-data">
                暂无数据
            </div>
            </Col>
        </Row>
        <div class="btn-group text-left margin-tb-10">
            <Button size="small" @click="closeDialog">取消</Button>
            <Button size="small" type="primary" class="margin-lr-10" @click="closeDialog('confirm')">确定</Button>
        </div>
    </div>
</template>

<script>
import api from '../../../common/api';

export default {
    name: 'RoleCom',
    data() {
        return {
            choiceData: [],
            rightList: [],
            historyList: [],
            searchTxt: '',
            appData: {}
        }
    },
    props: {
        obj: {
            type: Object,
            required: true
        },
        selectData: {
            type: Array,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: []
        }
    },
    created() {
        this.choiceData = this.selectData.map((item) => item.id)
    },
    methods: {
        closeDialog(type) {
            let data = []
            const curData = []
            const hasData = []
            // eslint-disable-next-line no-return-assign
            Object.keys(this.appData).forEach((item) => data = data.concat(this.appData[item]))
            // eslint-disable-next-line array-callback-return
            data.forEach((item) => {
                if (this.choiceData.includes(item.id)) {
                    curData.push(item)
                    hasData.push(item.id)
                }
            })
            // 获取当前没选中过但是历史有过的数据
            const noData = this.choiceData.filter((item) => !hasData.includes(item))
            if (noData.length > 0) {
                this.selectData.forEach((item) => {
                    if (noData.includes(item.id)) {
                        curData.push(item)
                    }
                })
            }
            this.$emit('closeDialog', type ? 'confirm' : 'cancel', curData)
        },
        searchRole() {
            if (this.searchTxt) {
                this.rightList = this.historyList.filter((item) => item.roleName.includes(this.searchTxt))
                return
            }
            this.rightList = this.historyList
        },
        getRoleList(appId, name) {
            api.getRoleName({ appId }).then((res) => {
                if (res.resultCode === 0) {
                    this.appData[appId] = res.data
                    // eslint-disable-next-line array-callback-return
                    const temp = res.data.map((item) => {
                        item.applicationName = name
                        return item
                    })
                    this.rightList = temp
                    this.historyList = temp
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
    .role-component {
        border: 1px solid var(--divider-color);
        position: absolute;
        margin-top: 4px;
        z-index: 1;
        width: 100%;
        border-radius: 6px;
        /deep/ .ivu-menu {
            background: var(--bg-color);
        }
        .ivu-menu-vertical .ivu-menu-item, .ivu-menu-vertical .ivu-menu-submenu-title {
            padding: 10px;
            line-height: 14px;
        }
        .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
            color: #ffffff!important;
        }
    }
    .role-list {
        height: 210px;
        overflow-y: auto;
    }
    .menu-group {
        height: 200px;
        overflow-y: scroll;
    }
    .page-title {
        margin-bottom: 20px;
    }
    .no-data {
        line-height: 200px;
    }
    /deep/ .ivu-menu-vertical .ivu-menu-item {
        color: var(--desc-font-color)!important;
        margin-top: 0;
    }
    /deep/ .ivu-checkbox-group-item {
        display: block;
    }
</style>
